<script setup lang="ts">
import VText from '~/components/ui/VText.vue'

import { useSeoListGeneration } from '~/composables/useSeoListGeneration'
import { useSeoListUrlDataToEntity } from '~/composables/useSeoListUrlDataToEntity'

import type { SeoListsAsyncData } from '~/types/influencerListTagSeo'

type Props = {
  urlData: SeoListsAsyncData['urlData']
}
const props = defineProps<Props>()

const { generateTopTitleFromUrlData } = useSeoListGeneration()
const { entities } = useSeoListUrlDataToEntity(props.urlData)

const text = computed<string>(() =>
  generateTopTitleFromUrlData(props.urlData, entities.value),
)
</script>

<template>
  <VText v-once cfg="sans/24/bold" html-tag="h1">{{ text }}</VText>
</template>
